import {
  getPlanTys,
  getPlanTy,
  setPlanTy,
  delPlanTy,
  modiPlanTy,
} from "@/api/setting";

const settingPlanTy = {
  state: {
    lists: [],
    planType: {},
  },
  mutations: {
    resetData(state) {
      Object.assign(state.planType, {
        planColHexaCd: "",
        planTyNm: "",
        note: "",
      });
    },
    getPlanType(state, payload) {
      state.planType = payload;
    },
    getPlanTypes(state, payload) {
      state.lists = payload;
    },
  },
  actions: {
    RESET_DATA({ commit }) {
      commit("resetData");
    },
    async FETCH_PLANTYPES({ commit }) {
      const { data } = await getPlanTys();
      commit("getPlanTypes", data.list);
    },
    async FETCH_PLANTYPE({ commit }, id) {
      const { data } = await getPlanTy(id);
      commit("getPlanType", data.form);
    },
    async ADD_PLANTYPE({ dispatch }, payload) {
      const { data } = await setPlanTy(payload);
      dispatch("FETCH_PLANTYPES");
      return data.ret;
    },
    async EDIT_PLANTYPE({ dispatch }, { planTyNo, newData }) {
      const { data } = await modiPlanTy(planTyNo, newData);
      dispatch("FETCH_PLANTYPES");
      return data.ret;
    },
    async DEL_PLANTYPE({ dispatch }, planTyNo) {
      await delPlanTy(planTyNo);
      dispatch("FETCH_PLANTYPES");
    },
  },
};

export default settingPlanTy;
